module.exports = __webpack_public_path__ + "zvetseni-prsou_41_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_41_after.jpg
// module id = 1335
// module chunks = 0